export type Lang = 'ru' | 'kk' | 'en'

export const translations: Record<Lang, Record<string, string>> = {
  ru: {
    // Navbar
    'nav.about': 'О Meelo',
    'nav.solutions': 'Решения',
    'nav.find_solution': 'Найдите своё решение',
    'nav.contact': 'Связаться с нами',
    'nav.mission': 'Миссия',
    'nav.phone': '+7 701 034 64 43',
    'nav.signin': 'Войти',

    // Hero
    'hero.eyebrow': '⭐ ДЛЯ РУКОВОДИТЕЛЕЙ ДЕТСКИХ САДОВ ⭐',
    'hero.title_prefix': 'Вы устали от',
    'hero.phrase_1': 'операционки',
    'hero.phrase_2': 'бумажной рутины',
    'hero.phrase_3': 'хаоса в процессах',
    'hero.phrase_4': 'вечных таблиц',
    'hero.title_suffix': 'в детском саду. Мы знаем как вас вытащить',
    'hero.subtitle_1': 'Meelo — система управления садом.',
    'hero.subtitle_2': 'Подключим, обучим и внедрим за 2 дня.',
    'hero.cta': 'Посмотреть как',
    'hero.scroll_cue': 'Смотреть решения ниже',

    // Dashboard
    'dashboard.label': 'Решения',
    'dashboard.title': 'Всё управление — в одной системе',
    'dashboard.card_label': 'Панель руководителя',
    'dashboard.card_title': 'Панель руководителя',
    'dashboard.benefit_1': 'От кого ещё ждём оплату',
    'dashboard.benefit_2': 'Кто уже совершил оплату',
    'dashboard.benefit_3': 'Сколько было потрачено на закуп продуктов',
    'dashboard.benefit_4':
      'Кто пришёл / не пришёл из воспитанников и сотрудников',
    'dashboard.benefit_5': 'Все филиалы в одном месте',
    'dashboard.switch_mobile': 'Мобильное приложение',
    'dashboard.switch_web': 'Веб-платформа',
    'dashboard.cta_more': 'Узнать подробнее',
    'dashboard.price': '20 000 ₸ / в месяц',

    // Solutions
    'solutions.label_method': 'Методика',
    'solutions.title_method': 'Методический блок',
    'solutions.desc_method':
      'Вся методическая документация — в порядке и готова к проверке',
    'solutions.bullet_method_1': 'Перспективные планы',
    'solutions.bullet_method_2': 'Циклограммы',
    'solutions.bullet_method_3': 'Конспекты к ООД',

    'solutions.label_food': 'Питание',
    'solutions.title_food': 'Питание и склад',
    'solutions.desc_food': 'Автоматизация всего процесса — от и до',
    'solutions.bullet_food_1':
      'Генерация меню (перспективное меню, техкарты, раскладка)',
    'solutions.bullet_food_2': 'Внедрение вашего меню в систему',
    'solutions.bullet_food_3': 'Автоматический закуп и списание по калькуляции',
    'solutions.bullet_food_4': 'Автоматическое ведение пищевых журналов',

    'solutions.label_finance': 'Финансы',
    'solutions.title_finance': 'Финансы и администрация',
    'solutions.desc_finance':
      'Прозрачная финансовая картина: от начисления оплаты до расчёта зарплат и контроля задолженности.',
    'solutions.bullet_finance_1': 'Автоматический расчёт оплаты',
    'solutions.bullet_finance_2': 'Контроль задолженности',
    'solutions.bullet_finance_3': 'Расчёт зарплаты и ФОТ',
    'solutions.bullet_finance_4': 'Дашборд руководителя',

    'solutions.label_parents': 'Родители',
    'solutions.title_parents': 'Родительский модуль',
    'solutions.desc_parents':
      'Удобное приложение для родителей со всей необходимой информацией',
    'solutions.bullet_parents_1': 'Лента дня',
    'solutions.bullet_parents_2': 'Меню',
    'solutions.bullet_parents_3': 'Расписание',
    'solutions.bullet_parents_4': 'Обращения в администрацию сада',
    'solutions.bullet_parents_5': 'Видеокамеры',

    // Results
    'results.title': 'Что меняется после внедрения?',
    'results.subtitle': 'Нажмите, чтобы увидеть разницу',
    'results.toggle_before': 'До Meelo',
    'results.toggle_after': 'После Meelo',

    'results.card_1_title_before': 'Данные разбросаны по чатам и таблицам',
    'results.card_1_desc_before':
      'Оплаты в одном чате, посещаемость в другом, закупки в Excel. Найти нужное — целый квест.',
    'results.card_1_title_after': 'Все данные в одном месте',
    'results.card_1_desc_after':
      'Оплаты, посещаемость, финансы и документы — в единой панели. Открыл — всё видно.',
    'results.card_1_stat_label': 'панель вместо 10 чатов',

    'results.card_2_title_before': 'Деньги утекают незаметно',
    'results.card_2_desc_before':
      'Ошибки в закупках, ручные расчёты, неучтённые расходы. Бюджет тает, причина неясна.',
    'results.card_2_title_after': 'Финансовая прозрачность с первого дня',
    'results.card_2_desc_after':
      'Автоматические расчёты, точные закупки, нулевые утечки. Каждый тенге на своём месте.',
    'results.card_2_stat_label': 'ошибок в расчётах',

    'results.card_3_title_before': 'Контроль требует постоянного присутствия',
    'results.card_3_desc_before':
      'Чтобы знать, что происходит в саду, нужно быть там лично. Отпуск? Командировка? Невозможно.',
    'results.card_3_title_after': 'Контроль из любой точки мира',
    'results.card_3_desc_after':
      'Уведомления, отчёты и статистика — в телефоне. Управляйте садом с пляжа, если захочется.',
    'results.card_3_stat_label': 'доступ к данным',

    // Social Proof
    'social.gardens': 'подключенных садов',
    'social.hours': 'часов экономии в неделю',

    // Final CTA
    'final.title':
      'Meelo упрощает работу в саду уже в первую неделю после внедрения!',
    'final.subtitle': 'Напишите нам — покажем демо и подскажем, с чего начать',
    'final.cta': 'Хочу узнать больше!',

    // Footer
    'footer.tagline': 'Платформа, которая облегчит операционку',
    'footer.pages': 'Страницы',
    'footer.home': 'Главная',
    'footer.info': 'Информация',
    'footer.privacy': 'Политика конфиденциальности',
    'footer.terms': 'Условия использования',
    'footer.copyright': '© 2025 Meelo. Все права защищены.',
  },
  kk: {
    // Navbar
    'nav.about': 'Meelo туралы',
    'nav.solutions': 'Шешімдер',
    'nav.find_solution': 'Шешіміңізді табыңыз',
    'nav.contact': 'Байланыс',
    'nav.mission': 'Миссия',
    'nav.phone': '+7 701 034 64 43',
    'nav.signin': 'Кіру',

    // Hero
    'hero.eyebrow': '⭐ БАЛАБАҚША БАСШЫЛАРЫНА АРНАЛҒАН ⭐',
    'hero.title_prefix': 'Сіз',
    'hero.phrase_1': 'операционкадан',
    'hero.phrase_2': 'қағаз бастылықтан',
    'hero.phrase_3': 'процестердегі хаостан',
    'hero.phrase_4': 'бітпейтін кестелерден',
    'hero.title_suffix': 'шаршадыңыз ба? Біз шешімін білеміз',
    'hero.subtitle_1': 'Meelo — балабақшаны басқару жүйесі.',
    'hero.subtitle_2': '2 күн ішінде қосып, үйретіп, енгізіп береміз.',
    'hero.cta': 'Қалай екенін көру',
    'hero.scroll_cue': 'Шешімдерді төменде қараңыз',

    // Dashboard
    'dashboard.label': 'Шешімдер',
    'dashboard.title': 'Барлық басқару — бір жүйеде',
    'dashboard.card_label': 'Басшы панелі',
    'dashboard.card_title': 'Басшы панелі',
    'dashboard.benefit_1': 'Төлемді кімнен күтіп отырмыз',
    'dashboard.benefit_2': 'Кім төлем жасады',
    'dashboard.benefit_3': 'Азық-түлік алуға қанша жұмсалды',
    'dashboard.benefit_4':
      'Тәрбиеленушілер мен қызметкерлерден кім келді / келмеді',
    'dashboard.benefit_5': 'Барлық филиалдар бір жерде',
    'dashboard.switch_mobile': 'Мобильді қосымша',
    'dashboard.switch_web': 'Веб-платформа',
    'dashboard.cta_more': 'Толығырақ білу',
    'dashboard.price': '20 000 ₸ / айына',

    // Solutions
    'solutions.label_method': 'Әдістеме',
    'solutions.title_method': 'Әдістемелік блок',
    'solutions.desc_method':
      'Барлық әдістемелік құжаттама — тәртіпте және тексеріске дайын',
    'solutions.bullet_method_1': 'Перспективалық жоспарлар',
    'solutions.bullet_method_2': 'Циклограммалар',
    'solutions.bullet_method_3': 'ҰОҚ конспектілері',

    'solutions.label_food': 'Тамақтану',
    'solutions.title_food': 'Тамақтану және қойма',
    'solutions.desc_food':
      'Барлық процесті автоматтандыру — басынан аяғына дейін',
    'solutions.bullet_food_1':
      'Мәзір генерациясы (перспективалық мәзір, техкарталар, жайма)',
    'solutions.bullet_food_2': 'Сіздің мәзіріңізді жүйеге енгізу',
    'solutions.bullet_food_3':
      'Калькуляция бойынша автоматты сатып алу және есептен шығару',
    'solutions.bullet_food_4': 'Тамақтану журналдарын автоматты жүргізу',

    'solutions.label_finance': 'Қаржы',
    'solutions.title_finance': 'Қаржы және әкімшілік',
    'solutions.desc_finance':
      'Айқын қаржылық көрініс: төлем есептеуден бастап жалақы мен қарыздарды бақылауға дейін.',
    'solutions.bullet_finance_1': 'Төлемді автоматты есептеу',
    'solutions.bullet_finance_2': 'Қарыздарды бақылау',
    'solutions.bullet_finance_3': 'Жалақы және Еңбекақы қорын есептеу',
    'solutions.bullet_finance_4': 'Басшы дашборды',

    'solutions.label_parents': 'Ата-аналар',
    'solutions.title_parents': 'Ата-аналар модулі',
    'solutions.desc_parents':
      'Ата-аналарға арналған барлық қажетті ақпараты бар ыңғайлы қосымша',
    'solutions.bullet_parents_1': 'Күн лентасы',
    'solutions.bullet_parents_2': 'Мәзір',
    'solutions.bullet_parents_3': 'Кесте',
    'solutions.bullet_parents_4': 'Балабақша әкімшілігіне өтініштер',
    'solutions.bullet_parents_5': 'Бейнекамералар',

    // Results
    'results.title': 'Енгізгеннен кейін не өзгереді?',
    'results.subtitle': 'Айырмашылықты көру үшін басыңыз',
    'results.toggle_before': 'Meelo-ға дейін',
    'results.toggle_after': 'Meelo-дан кейін',

    'results.card_1_title_before': 'Деректер чаттар мен кестелерде шашыраңқы',
    'results.card_1_desc_before':
      'Төлемдер бір чатта, қатысу басқасында, сатып алулар Excel-де. Керектіні табу — үлкен квест.',
    'results.card_1_title_after': 'Барлық деректер бір жерде',
    'results.card_1_desc_after':
      'Төлемдер, қатысу, қаржы және құжаттар — бірыңғай панельде. Аштыңыз — бәрі көрініп тұр.',
    'results.card_1_stat_label': '10 чаттың орнына 1 панель',

    'results.card_2_title_before': 'Ақша байқатпай кетеді',
    'results.card_2_desc_before':
      'Сатып алудағы қателер, қолмен есептеулер, ескерілмеген шығындар. Бюджет азаяды, себебі белгісіз.',
    'results.card_2_title_after': 'Бірінші күннен бастап қаржылық ашықтық',
    'results.card_2_desc_after':
      'Автоматты есептеулер, дәл сатып алулар, нөлдік шығындар. Әр теңге өз орнында.',
    'results.card_2_stat_label': 'есептеулерде 0 қате',

    'results.card_3_title_before': 'Бақылау үнемі қатысуды талап етеді',
    'results.card_3_desc_before':
      'Бақшада не болып жатқанын білу үшін сол жерде болу керек. Демалыс? Іссапар? Мүмкін емес.',
    'results.card_3_title_after': 'Әлемнің кез келген нүктесінен бақылау',
    'results.card_3_desc_after':
      'Хабарламалар, есептер және статистика — телефонда. Қаласаңыз, бақшаны жағажайдан басқарыңыз.',
    'results.card_3_stat_label': 'деректерге 24/7 қолжетімділік',

    // Social Proof
    'social.gardens': 'қосылған балабақшалар',
    'social.hours': 'аптасына үнемделген сағат',

    // Final CTA
    'final.title':
      'Meelo енгізілгеннен кейінгі бірінші аптада-ақ бақша жұмысын жеңілдетеді!',
    'final.subtitle':
      'Бізге жазыңыз — демо көрсетіп, неден бастау керектігін айтамыз',
    'final.cta': 'Толығырақ білгім келеді!',

    // Footer
    'footer.tagline': 'Операционканы жеңілдететін платформа',
    'footer.pages': 'Беттер',
    'footer.home': 'Басты бет',
    'footer.info': 'Ақпарат',
    'footer.privacy': 'Құпиялылық саясаты',
    'footer.terms': 'Пайдалану шарттары',
    'footer.copyright': '© 2025 Meelo. Барлық құқықтар қорғалған.',
  },
  en: {
    // Navbar
    'nav.about': 'About Meelo',
    'nav.solutions': 'Solutions',
    'nav.find_solution': 'Find Your Solution',
    'nav.contact': 'Contact Us',
    'nav.mission': 'Mission',
    'nav.phone': '+7 701 034 64 43',
    'nav.signin': 'Sign in',

    // Hero
    'hero.eyebrow': '⭐ FOR KINDERGARTEN DIRECTORS ⭐',
    'hero.title_prefix': 'Are you tired of',
    'hero.phrase_1': 'daily operations',
    'hero.phrase_2': 'paperwork routine',
    'hero.phrase_3': 'process chaos',
    'hero.phrase_4': 'endless spreadsheets',
    'hero.title_suffix': 'in your kindergarten? We know how to save you',
    'hero.subtitle_1': 'Meelo — kindergarten management system.',
    'hero.subtitle_2': 'Setup, training, and launch in 2 days.',
    'hero.cta': 'See How',
    'hero.scroll_cue': 'See solutions below',

    // Dashboard
    'dashboard.label': 'Solutions',
    'dashboard.title': 'All management — in one system',
    'dashboard.card_label': 'Director Dashboard',
    'dashboard.card_title': 'Director Dashboard',
    'dashboard.benefit_1': "Who hasn't paid yet",
    'dashboard.benefit_2': 'Who has already paid',
    'dashboard.benefit_3': 'How much spent on groceries',
    'dashboard.benefit_4': 'Attendance of students and staff',
    'dashboard.benefit_5': 'All branches in one place',
    'dashboard.switch_mobile': 'Mobile App',
    'dashboard.switch_web': 'Web Platform',
    'dashboard.cta_more': 'Learn More',
    'dashboard.price': '20 000 ₸ / month',

    // Solutions
    'solutions.label_method': 'Methodology',
    'solutions.title_method': 'Methodology Block',
    'solutions.desc_method':
      'All methodological documentation — in order and ready for inspection',
    'solutions.bullet_method_1': 'Perspective plans',
    'solutions.bullet_method_2': 'Cyclograms',
    'solutions.bullet_method_3': 'Lesson notes',

    'solutions.label_food': 'Nutrition',
    'solutions.title_food': 'Nutrition & Warehouse',
    'solutions.desc_food': 'Full process automation — from A to Z',
    'solutions.bullet_food_1':
      'Menu generation (perspective menu, tech cards, layout)',
    'solutions.bullet_food_2': 'Implementation of your menu into the system',
    'solutions.bullet_food_3':
      'Automatic procurement and write-off by calculation',
    'solutions.bullet_food_4': 'Automatic maintenance of food logs',

    'solutions.label_finance': 'Finance',
    'solutions.title_finance': 'Finance & Administration',
    'solutions.desc_finance':
      'Transparent financial picture: from payment calculation to payroll and debt control.',
    'solutions.bullet_finance_1': 'Automatic payment calculation',
    'solutions.bullet_finance_2': 'Debt control',
    'solutions.bullet_finance_3': 'Payroll calculation',
    'solutions.bullet_finance_4': 'Director dashboard',

    'solutions.label_parents': 'Parents',
    'solutions.title_parents': 'Parent Module',
    'solutions.desc_parents':
      'Convenient app for parents with all necessary information',
    'solutions.bullet_parents_1': 'Day feed',
    'solutions.bullet_parents_2': 'Menu',
    'solutions.bullet_parents_3': 'Schedule',
    'solutions.bullet_parents_4': 'Requests to administration',
    'solutions.bullet_parents_5': 'Video cameras',

    // Results
    'results.title': 'What changes after implementation?',
    'results.subtitle': 'Click to see the difference',
    'results.toggle_before': 'Before Meelo',
    'results.toggle_after': 'After Meelo',

    'results.card_1_title_before': 'Data scattered across chats and tables',
    'results.card_1_desc_before':
      'Payments in one chat, attendance in another, purchases in Excel. Finding what you need is a quest.',
    'results.card_1_title_after': 'All data in one place',
    'results.card_1_desc_after':
      'Payments, attendance, finances, and documents — in a single panel. Open it — see everything.',
    'results.card_1_stat_label': 'panel instead of 10 chats',

    'results.card_2_title_before': 'Money leaks unnoticed',
    'results.card_2_desc_before':
      'Procurement errors, manual calculations, unaccounted expenses. Budget melts, reason unclear.',
    'results.card_2_title_after': 'Financial transparency from day one',
    'results.card_2_desc_after':
      'Automatic calculations, precise procurement, zero leaks. Every tenge in its place.',
    'results.card_2_stat_label': '0 calculation errors',

    'results.card_3_title_before': 'Control requires constant presence',
    'results.card_3_desc_before':
      "To know what's happening in the garden, you need to be there personally. Vacation? Business trip? Impossible.",
    'results.card_3_title_after': 'Control from anywhere in the world',
    'results.card_3_desc_after':
      'Notifications, reports, and statistics — in your phone. Manage the garden from the beach if you want.',
    'results.card_3_stat_label': '24/7 data access',

    // Social Proof
    'social.gardens': 'connected kindergartens',
    'social.hours': 'hours saved per week',

    // Final CTA
    'final.title':
      'Meelo simplifies work in the garden in the very first week!',
    'final.subtitle':
      "Write to us — we'll show a demo and tell you where to start",
    'final.cta': 'I want to learn more!',

    // Footer
    'footer.tagline': 'Platform that eases operations',
    'footer.pages': 'Pages',
    'footer.home': 'Home',
    'footer.info': 'Information',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Use',
    'footer.copyright': '© 2025 Meelo. All rights reserved.',
  },
}
